import { ComplyCubeError } from "./ComplyCubeError";

export class ComplyCubeApiError extends ComplyCubeError {
  public readonly responseBody: unknown;
  public readonly statusCode: number;
  public readonly type: string;
  public readonly param: unknown;

  private constructor(
    message: string,
    responseBody: unknown,
    statusCode: number,
    type: string,
    param: unknown
  ) {
    super(message);
    this.name = "ComplyCubeApiError";

    this.responseBody = responseBody;
    this.statusCode = statusCode;
    this.type = type;
    this.param = param;
  }

  public static fromResponse(
    responseBody: unknown,
    statusCode: number
  ): ComplyCubeApiError {
    const innerErrorData: unknown =
      responseBody instanceof Object ? (responseBody as any) : {};

    const innerError: {
      type?: unknown;
      message?: unknown;
      param?: unknown;
    } = innerErrorData instanceof Object ? innerErrorData : {};

    const type = `${innerError.type || "unknown"}`;
    const message = `${innerError.message || responseBody}`;
    const param = innerError.param;
    const fullMessage = `${message} (status code ${statusCode})`;

    return new ComplyCubeApiError(
      fullMessage,
      responseBody,
      statusCode,
      type,
      param
    );
  }

  public isClientError(): boolean {
    return this.statusCode < 500;
  }
}
